import React, { FC } from 'react';
import { Provider } from 'react-redux';
import Form from './components/Form/Form';

import configueStore from './configureStore';
import { IConfig } from './sharedInterfaces/SharedInterfaces';

const App: FC<IConfig> = ({ pages, settings }) => {
  const store = configueStore(pages, settings);
  return (
    <Provider store={store}>
      <Form pages={pages} settings={settings} />
    </Provider>
  );
};

export default App;
